import React, { useState } from 'react';

const FeatureCard = ({ title, description, onHover }) => {
  return (
    <div 
      className="bg-white p-6 rounded-lg shadow-md transition-all duration-300 ease-in-out"
      onMouseEnter={() => onHover(title)} // Call onHover with the title
    >
      <h4 className="text-xl font-bold text-indigo-900 mb-2">{title}</h4>
      <p className="text-gray-600">{description}</p>
    </div>
  );
};

const WhyChooseVirginVoyages = () => {
  const [activeFeature, setActiveFeature] = useState('Unique Venues');

  const features = [
    {
      title: "Unique Venues",
      description: "Discover an array of stunning spaces aboard our ships, from intimate lounges to breathtaking outdoor decks, each offering a distinctive atmosphere for your perfect vacation moments.",
      image: "https://cdn.speedsize.com/eb8d0010-7300-4129-8a6d-74bc221f9caf/https://www.virginvoyages.com/dam/jcr:a4b6fa0f-edcc-4bfb-9d87-1e7be7de14ea/IMG-ENT-Red-Room-Duel-Reality-v1-01-mollychoma-145-1600x900.jpg"
    },
    {
      title: "Exciting Activities",
      description: "Join fellow sailors in an incredible range of activities designed for fun and adventure, creating unforgettable memories while sailing across beautiful ocean horizons.",
      image: "https://cdn.speedsize.com/eb8d0010-7300-4129-8a6d-74bc221f9caf/https://www.virginvoyages.com/dam/jcr:eb02767d-b0af-47ef-8747-1ffec994d3e6/IMG-ENT-The-Groupie-lifestyle-v1-01-3479-1600x900.jpg"
    },
    {
      title: "Culinary Delights",
      description: "Savor extraordinary dining experiences with diverse cuisines crafted by world-class chefs, making every meal aboard an adventure for your taste buds.",
      image: "https://cdn.speedsize.com/eb8d0010-7300-4129-8a6d-74bc221f9caf/https://www.virginvoyages.com/dam/jcr:7217523a-b293-4a29-bacc-252876c3f3f2/Eat-Landing-Extra%20Virgin-1200x1440-2.png"
    },
    {
      title: "Luxury Amenities",
      description: "Indulge in our premium amenities, from rejuvenating spas to state-of-the-art fitness centers and spectacular entertainment venues that make your voyage truly extraordinary.",
      image: "https://cdn.speedsize.com/eb8d0010-7300-4129-8a6d-74bc221f9caf/https://www.virginvoyages.com/dam/jcr:7ce8d0b1-9a57-4108-a2d2-95793aad95bb/Wellbeing-Landing-Training%20Camp-component%206-800x800.png"
    }
  ];

  return (
    <section className="bg-gray-100 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
            Why Sail with <span className="text-red-600">Virgin Voyages</span>?
          </h2>
          <p className="mt-4 text-xl text-gray-600">
            Experience a revolutionary approach to cruising, where luxury meets adventure on the high seas.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8">
          <div className="space-y-8">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Unparalleled Experience at Sea
              </h3>
              <p className="text-gray-600 mb-6">
                Sailing with Virgin Voyages means embarking on an unforgettable journey filled with luxury amenities, breathtaking views, and exceptional service at every turn.
              </p>
            </div>
            <div className="relative pb-[100%] md:pb-0 h-[700px]">
              <img
                src={features.find(f => f.title === activeFeature).image}
                alt={activeFeature}
                className="rounded-lg shadow-xl w-full h-full object-cover transition-opacity duration-300 ease-in-out"
              />
            </div>
          </div>

          <div className="space-y-8 mt-16 md:mt-0">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Personalized Sailing Experience
              </h3>
              <p className="text-gray-600 mb-6">
                Our dedicated crew ensures your voyage is tailored to your desires, creating the perfect balance of relaxation and adventure for an unforgettable experience at sea.
              </p>
            </div>
            <div className="grid grid-cols-1 gap-6">
              {features.map((feature) => (
                <FeatureCard
                  key={feature.title}
                  title={feature.title}
                  description={feature.description}
                  onHover={setActiveFeature}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseVirginVoyages;
